import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: 'Preciso comprar ingredientes caros?',
    a: 'Não. O cardápio usa alimentos comuns, fáceis de encontrar em supermercado.'
  }, {
    q: 'Vou passar fome?',
    a: 'Não. O foco é leveza com saciedade, não restrição extrema.'
  }, {
    q: 'Serve para menopausa?',
    a: 'Sim, o protocolo foi pensado especialmente para mulheres 40+, incluindo perimenopausa e menopausa.'
  }, {
    q: 'Tenho pressão alta. Posso fazer?',
    a: 'O protocolo é alimentar e não substitui orientação médica. Caso você tenha pressão alta, diabetes, doença renal, use medicamentos ou tenha qualquer condição de saúde, consulte seu médico antes de iniciar.'
  }, {
    q: 'Quanto tempo preciso por dia?',
    a: 'Poucos minutos para seguir o checklist e organizar suas refeições. A ideia é facilitar, não complicar.'
  }, {
    q: 'O acesso é vitalício?',
    a: 'Sim. Após a compra, você recebe o acesso no seu e-mail.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 md:py-24 bg-brand-cream" data-id="element-32">
      <div className="max-w-3xl mx-auto px-5 md:px-8" data-id="element-33">
        <div className="text-center mb-12" data-id="element-34">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark" data-id="element-35">
            Perguntas Frequentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-36">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl border border-brand-sage/30 overflow-hidden shadow-sm" data-id="element-37">
              <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-38">
                <span className="font-bold text-brand-dark pr-4" data-id="element-39">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-sage-dark transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-40" />
              </button>
              <AnimatePresence data-id="element-41">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-42">
                    <div className="px-6 pb-5 text-brand-text/80" data-id="element-43">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}